import { EventEmitter } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { AchooFilterBoxComponent } from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { ActionDetails, ActionSource, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
var SendToReviewComponent = /** @class */ (function () {
    function SendToReviewComponent(userService, translate, eventTracker) {
        this.userService = userService;
        this.translate = translate;
        this.eventTracker = eventTracker;
        this.DO_NOT_SEND_EMAIL_OPTION_ID = -1;
        this.ALL_OPTION_ID = 0;
        this.changeReviewerEvent = new EventEmitter();
        this.needToReview = false;
        this.selectedReviewers = [];
    }
    SendToReviewComponent.prototype.ngOnInit = function () {
        this.loadReviewerList();
    };
    SendToReviewComponent.prototype.loadReviewerList = function () {
        var _this = this;
        this.reviewerList = [{
                id: this.DO_NOT_SEND_EMAIL_OPTION_ID,
                name: 'Don\'t send any emails'
            }];
        this.userService.loadReviewerList(this.userService.getCompanyId()).subscribe(function (res) {
            if (res && res.length > 0) {
                var reviewerOptionList = [{
                        id: _this.ALL_OPTION_ID,
                        name: 'All'
                    }];
                reviewerOptionList.push.apply(reviewerOptionList, res);
                _this.reviewerList = _this.reviewerList.concat(reviewerOptionList);
            }
        }, function (err) {
            _this.reviewerList = [];
        });
    };
    SendToReviewComponent.prototype.onChangeReviewer = function (evt) {
        var _this = this;
        if (this.selectedReviewers.length === 0) {
            setTimeout(function () {
                _this.needToReview = false;
            }, 200);
        }
        else {
            this.changeReviewerEvent.emit({
                addForReview: this.needToReview,
                selectedReviewers: this.selectedReviewers.indexOf(this.DO_NOT_SEND_EMAIL_OPTION_ID) >= 0 ? [] : this.selectedReviewers,
                needToSendMPEvent: true
            });
        }
    };
    SendToReviewComponent.prototype.onSelectReviewer = function (evt) {
        var _this = this;
        var selectedReviewerIds = evt.map(function (s) { return s.id; });
        var lastSelectedReviewer = selectedReviewerIds[selectedReviewerIds.length - 1];
        if (lastSelectedReviewer === this.ALL_OPTION_ID) {
            var allUsers = this.reviewerList.filter(function (r) { return r.id !== _this.ALL_OPTION_ID && r.id !== _this.DO_NOT_SEND_EMAIL_OPTION_ID; }).map(function (re) { return re.id; });
            var hasSelectedAllUser = allUsers.filter(function (u) { return selectedReviewerIds.indexOf(u) < 0; }).length === 0;
            if (hasSelectedAllUser) {
                this.selectedReviewers = [];
            }
            else {
                this.selectedReviewers = allUsers;
            }
        }
        else if (lastSelectedReviewer === this.DO_NOT_SEND_EMAIL_OPTION_ID) {
            this.selectedReviewers = [this.DO_NOT_SEND_EMAIL_OPTION_ID];
        }
        else {
            var selectedOptions = this.reviewerList.filter(function (reviewerItem) { return evt.find(function (evtItem) { return evtItem.id !== _this.DO_NOT_SEND_EMAIL_OPTION_ID && evtItem.id !== _this.ALL_OPTION_ID && evtItem.id === reviewerItem.id; }); }).map(function (so) { return so.id; });
            this.selectedReviewers = selectedOptions;
        }
    };
    SendToReviewComponent.prototype.onSwitch = function () {
        if (!this.needToReview) {
            this.selectedReviewers = [];
        }
        this.changeReviewerEvent.emit({
            addForReview: this.needToReview,
            selectedReviewers: this.selectedReviewers,
            needToSendMPEvent: false
        });
        if (this.reviewerListComp) {
            this.reviewerListComp.ngSelect.isOpen = this.needToReview;
            this.reviewerListComp.ngSelect.isFocused = this.needToReview;
        }
    };
    SendToReviewComponent.prototype.eventDataForSegment = function () {
        return {
            action: UserActionType.ACTION,
            item: Page.INFLUENCER_GROUP,
            target: {
                type: TargetType.REQUEST_REVIEW
            },
            params: {
                action: UserActionType.TOGGLE,
                actionDetails: ActionDetails.ADDED_INFLUENCERS,
                source: ActionSource.ACTION_VIEW,
            }
        };
    };
    Object.defineProperty(SendToReviewComponent.prototype, "placeholder", {
        get: function () {
            var _this = this;
            if (!this.selectedReviewers || !this.reviewerList) {
                return null;
            }
            if (this.selectedReviewers.length === 0) {
                return this.translate.instant('request_review.action_bar.no_selection');
            }
            if (this.selectedReviewers.length === 1) {
                var selectedReviewer = this.reviewerList.find(function (r) { return r.id === _this.selectedReviewers[0]; });
                return selectedReviewer ? selectedReviewer.name : null;
            }
            if (this.selectedReviewers.length > 0) {
                return this.translate.instant('request_review.action_bar.more_than_one_selection', {
                    numOfSelection: this.selectedReviewers.length
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    return SendToReviewComponent;
}());
export { SendToReviewComponent };



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/send-to-review/send-to-review.component.ts.pre-build-optimizer.js